import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

// const Dato = ({styles, elemento}) => {
//   return(
//     <p style={styles.elemLis_1}>{elemento.descrRecurso}</p>
//   )};

// const DescrTipoRec = props => <p>{props.elemento.descrTipoRec} ={">"} {props.elemento.areaAprovech}</p>;

// const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
//   return (
//     <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
//       <div className="item">
//         <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
//             <div className="right floated content" style={styles.elemLis_2}>
//                 <div><DescrTipoRec elemento={elemento.tiporec} /></div>
//             </div>
//             <List.Header>
//                 <div className="floated content" style={styles.subElemLis_1}>
//                     <a className="header"><Dato styles={styles} elemento={elemento}/></a>
//                 </div>
//             </List.Header>
//         </List.Item>
//       </div>
//     </div>
//   )
// };

// const Lista = ({styles, list, handleClickidLista}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       {nivel1Detalle}
//     </div>
//   )
// };


//Clases
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.tiporec.areaAprovech}</td>
      <td className=''>{elemento.descrRecurso}</td>
      <td className=''>{elemento.tiporec.descrTipoRec}</td>
      <td className=''>{elemento.descrDpto}</td>
      <td className=''>{elemento.nombreCiudad}</td>
      <td className=''>{elemento.dirArchIn}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfRec2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a253501 = autorizacUA.findIndex( autorizac => autorizac === "253501" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Recursos" btnNuevo={a253501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '12%'}}>Area de aprovechamiento</th>
                <th className='' style={{width: '26%'}}>Descripción</th>
                <th className='' style={{width: '12%'}}>Tipo de recurso</th>
                <th className='' style={{width: '15%'}}>Departamento</th>
                <th className='' style={{width: '15%'}}>Ciudad</th>
                <th className='' style={{width: '20%'}}>Carpeta para recibir archivos de recaudo</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfRec2
